import axios from 'axios'

let client = axios.create({
  withCredentials: true,
  headers: {
    'Accept': 'application/json'
  }
})

let vueStore = null
let vueRoot = null

// currently I do not find an appropriate to catch reject of promise globally
// I wish I could find a solution before the end of this project
// lol, sadly
// const Errors = [
//   'Error',
//   'RequireWritePermissionError',
//   'NoQuotaError',
//   'ProjectLockedError',
//   'PermissionError',
//   'NotFoundError'
// ]

client.interceptors.response.use(response => {
  if (vueStore) {
    let enabled = !!response.headers['x-sneaky-mode']
    vueStore.dispatch('set_sneaky_mode', enabled)
  }
  return response
}, error => {
  var ret = Promise.reject(error)
  setTimeout(() => ret.catch(error => {
    if (error && error.mute) return
    if (!vueRoot) return
    if (error.response.status >= 500) {
      vueRoot.$message({
        message: '服务器暂时异常，请重试操作或刷新页面',
        type: 'error',
        duration: 3000
      })
    } else if (error.response.status >= 400 && error.response.status !== 401) {
      let data = error.response.data
      let popup = true

      // NoQuotaError for post export request do not need popup message
      if (data.type === 'NoQuotaError' && /\/export$/.test(error.response.config.url) && error.response.config.method === 'post') {
        popup = false
      }

      if (popup) {
        vueRoot.$message({
          message: data.message,
          type: 'error',
          duration: 1500,
          onClose: () => {
            if (['NotFoundError', 'PermissionError'].indexOf(data.type) >= 0) {
              vueRoot.$router.push('/projects')
            }
          }
        })
      }
    }
  }))
  return ret
})

function expandPath(path) {
  return process.env.API_ROOT + path.replace(/^\//, '')
}

export default class ApiBase {
  static setVueStore(store) {
    vueStore = store
  }

  static setVueRoot(root) {
    vueRoot = root
  }

  static get(path, params, config = {}) {
    return client.get(expandPath(path), Object.assign({}, config, {
      params: Object.assign({}, params, { '_timestamp': Date.now() })
    }))
  }

  static post(path, params, config = {}) {
    return client.post(expandPath(path), params, config)
  }
  static put(path, params, config = {}) {
    return client.put(expandPath(path), params, config)
  }
  //
  static delete(path, params) {
    return client.delete(expandPath(path), { params: params })
  }
}



// WEBPACK FOOTER //
// ./src/api/api_base.js